import { useEffect } from 'react';
import type React from 'react';

import isEmail from 'validator/lib/isEmail';

import { Button, Image, Text } from '@change/ds-core-ui';
import { OpenInNewIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import gmailIcon from '#src/app/pages/loginOrSignup/shared/assets/gmail.svg';

import { useForgotPasswordStep } from './hooks/useForgotPasswordStep';

export const ForgotPasswordStep: React.FC<EmptyProps> = () => {
	const {
		data: { email },
		actions: { trackOpenInGmailClick, trackStepView },
	} = useForgotPasswordStep();

	useEffect(() => {
		trackStepView(!isEmail(email, { host_blacklist: ['gmail.com'] }));
	}, [trackStepView, email]);
	return (
		<>
			{!isEmail(email, { host_blacklist: ['gmail.com'] }) && (
				<div>
					<Button
						className="w-full"
						variant="secondary"
						as="a"
						onClick={trackOpenInGmailClick}
						size="large"
						target="_blank"
						href="https://mail.google.com/mail/u/0/#search/from%3A(%40a.change.org)+in%3Aanywhere"
						data-qa="forgot-password-open-gmail-button"
					>
						<div className="flex items-center">
							<Image className="h-5 w-5" aria-hidden="true" src={gmailIcon} />
							<Text fontWeight="bold" className="mx-2" as="span" size="large">
								<Translate value="corgi.login_or_signup.forgot_password.open_gmail_button" />
							</Text>
							<OpenInNewIcon size="small" />
						</div>
					</Button>
				</div>
			)}
		</>
	);
};
